import React from 'react';
import { Redirect, Route, IndexRoute } from 'react-router';

import AppWindow from './components/containers/app-window';

import Dashboard from './components/dashboard/';


import OnBoarding from './components/onboarding/on-boarding';

import TempConnections from './components/temp-connections/temp-connections';
import TempConnectionsSend from './components/temp-connections/temp-connections-send';
import TempConnectionsResults from './components/temp-connections/temp-connections-results';
import TempConnectionsAdd from './components/temp-connections/temp-connections-add';

import Integration from './components/integration/integration';
import ProductMapping from './components/integration/export/export-container';
import IntegrationRouter from './components/integration/integrationContainer';

import ConnectionsContainer from './components/connections/connections-container';
import Connections from './components/connections/connections';

import ProfileRouter from './components/profile/profileContainer';
import Profile from './components/profile/profile';

import ProfileCompleteSplash from './components/splash-pages/profile-complete-splash';

import PartnerFinderRouter from './components/partner-finder/container-partnerFinder';
import PartnerFinderOptions from './components/connections/options-partnerFinder';
import PartnerFinderResults from './components/partner-finder/results-partnerFinder';

import ContractingRouter from './components/contracting/contracting-container';

import NotFound from './components/errors/page-not-found';

import ContractingCardIntro from './components/contracting/card-intro';

import SupplierWizard from './components/contracting/supplier-wizard/container';
import ContractRequestWizard from './components/contracting/supplier-wizard/respond-contract-request/container';
import SupplierInitiatedWizardWithAlloments from './components/contracting/supplier-wizard/supplier-initiated/container-allotments';
import ContractContainer from './components/contracting/contract-activities-products/contract-container/contract-container';
import DraftContainer from './components/contracting/contract-activities-products/draftNTemplate-container/draftNTemplate-container';
import ContractPolicies from './components/contracting/contract-activities-products/contract-container/contract-policies';
import DraftNTemplatePolicies from './components/contracting/contract-activities-products/draftNTemplate-container/contract-policies';
import ContractWorkspace from './components/contracting/contract-activities-products/contract-policies/contract-request-buyer-view/router';
import ContractWorkspaceMainContent from './components/contracting/contract-activities-products/contract-policies/contract-request-buyer-view/main-content';
import ContractActivities from './components/contracting/comments/router';
import NotesInContracting from './components/contracting/notes';
import ContractProduct from './components/contracting/contract-activities-products/product/product';

import MassRateChange from './components/contracting/mass-rate-change/mass-rate-change-container';

import ContractListRouter from './components/contracting/contract-list/contract-list-container';
import ContractDashboard from './components/contracting-dashboard/components/container';
import ContractReports from './components/contracting-reports/container';
import DiffReportsRouter from './components/contracting-reports/diff-report/router';
import DiffReports from './components/contracting-reports/diff-report/diff-report-page';
import DiffSelectDocs from './components/contracting-reports/diff-report/select-docs-page';
import TemplateListRouter from './components/contracting/template-list/template-list-container';
import MainTemplateList from './components/contracting/template-list/list/container';
import TemplateGroupWizardRouter from './components/contracting/template-list/create-group/create-group-router';
import CreateTemplateDraftRouter from './components/contracting/template-list/create-template-draft/router-container';
import TemplatePartnersRouter from './components/contracting/contract-activities-products/draftNTemplate-container/partner-list';
import TemplateChangeLog from './components/contracting/contract-activities-products/draftNTemplate-container/change-log/change-log-router';

/* Settings Components */
import SettingsRouter from './components/settings/settingsContainer';

/* Upgrade Component */
import UpgradeContainer from './components/upgrade/upgrade-container';
import Upgrade from './components/upgrade';

import MessagingRouter from './components/messaging/messaging-container';
import RightSideConv from './components/messaging/singleConv/rgtMsgsRouter';

/* News Feed */
import NewsFeed from './components/newsfeed/newsfeed-container';
import Post from './components/newsfeed/postPage/post';
import InternalPost from './components/newsfeed/postPage/internal-container';
import NFMetadataRouter from './components/newsfeed/ownerMetaDataPages/main-router';
import OwnPosts from './components/newsfeed/ownerMetaDataPages/posts';
import Followers from './components/newsfeed/ownerMetaDataPages/followers';
import Follows from './components/newsfeed/ownerMetaDataPages/follows';

/* Workspace */
import Workspace from './components/workspace/container';

/* Asset Consolidation */
import AssetsConsolidationRouter from './components/assets-consolidation/router';

/* Partner Details */
import partnerDetails from './components/partner-details';

/* Secondary Template*/
import CreateMasterTemplate from './components/contracting/master-template-list/create-master-template';
import MasterTemplateList from './components/contracting/master-template-list/list';
import SupplierUpdatesQueue from './components/contracting/supplier-updates-queue/router';
import MasterTemplateRouter from './components/contracting/master-template/router';
import AssoicateMasterTemplateWizard from './components/contracting/master-template/apply-master-wizards/apply-one-master-to-multiple/wizard';
import PickMasterTemplate from './components/contracting/master-template/apply-master-wizards/pick-one-master-for-one-template/wizard';

export const routes = (
  <Route component={AppWindow}>

    <Redirect from="/" to="/dashboard" />
    <Redirect from="/settings" to="/settings/my-settings" />

    {/* <Redirect from="/contracting/dashboard" to="/contracting/contract-list/recent" /> */}
    <Route path="/dashboard" component={Dashboard} />
    <Route path="/newsfeed" component={NewsFeed} />

    <Route path="/workspace" component={Workspace} />
    <Route path="/workspace/:connectionId" component={Workspace} />
    <Route path="/workspace/:connectionId/:channelId" component={Workspace} />

    <Route path="/assets-consolidation/:hashToken" component={AssetsConsolidationRouter} />
    <Route component={NFMetadataRouter}>
      <Route component={OwnPosts} path="/newsfeed/meta/posts" />
      <Route component={Followers} path="/newsfeed/meta/followers" />
      <Route component={Follows} path="/newsfeed/meta/follows" />
    </Route>

    <Route path="/partnerdetails/:partner" component={partnerDetails} />

    <Route component={SettingsRouter} path="/settings/:activeRoute" />

    <Route path="/upgrade" component={UpgradeContainer}>
      <IndexRoute component={Upgrade} />
    </Route>

    <Route component={MessagingRouter} path="/messaging/:filter">
      <Route component={RightSideConv} path="/messaging/:filter/conversation/:convId"/>
      <Route component={ContractActivities} path="/messaging/:filter/contract/:contractId" />
    </Route>

    <Route component={ProfileRouter}>
      <Route component={Profile} path="/profile" />
      <Route component={Profile} path="/profile/locations/:locationId"/>
      <Route component={Profile} path="/profile/product/:productId"/>
      <Route component={Profile} path="/company/:companyId" />
      <Route component={Profile} path="/locations/:locationId" />
      <Route component={Profile} path="/product/:productId" />
    </Route>

    <Route component={OnBoarding} path="/onboarding" />
    <Route component={NotFound} path="/notfound" />

    <Route component={ProfileCompleteSplash} path="/profile-complete-splash" />
    <Route component={PartnerFinderOptions} path="/connections-splash" />

    <Redirect from="/connections" to="/connections/connected"/>
    <Route component={ConnectionsContainer} path="/connections">
      <Route path="/connections/connected" component={Connections} />
      <Route path="/connections/requests" component={Connections} />
      <Route path="/connections/invitations" component={Connections} />
    </Route>

    <Route component={TempConnections}>
      <Route path="/connections/add-connections" component={TempConnectionsAdd}/>
      <Route path="/connections/add-connections/send" component={TempConnectionsSend} />
      <Route path="/connections/add-connections/results" component={TempConnectionsResults} />
    </Route>

    <Route path="/integration" component={IntegrationRouter}>
      <Route component={ProductMapping} path="/integration/product-mapping/:contractID" />
      <Route component={Integration} path="/integration/authentication" />
      <Route component={Integration} path="/integration/contracts" />
      <Route component={Integration} path="/integration/settings/:settingType" />
    </Route>

    <Route path="/partner-finder/search" component={PartnerFinderRouter}>
      <Redirect from="/partner-finder/search" to="/partner-finder/results" />
      <Route component={PartnerFinderResults} path="/partner-finder/results"/>
    </Route>

    <Route path="/post/:postId" component={InternalPost}>
      <IndexRoute component={Post} />
    </Route>

    <Route path="/contracting/create-master-template" component={CreateMasterTemplate}/>
    <Route path="/contracting/pick-master-template/:templateDraftId" component={PickMasterTemplate} />
    <Route path="/contracting/master-template/:id" component={MasterTemplateRouter}>
      <Route path="/contracting/master-template/:id/associate" component={AssoicateMasterTemplateWizard}/>
    </Route>

    <Route path="/contracting" component={ContractingRouter}>
      <IndexRoute component={ContractingCardIntro} />
      <Route component={ContractWorkspace} path="/contracting/workspace/:contractId">
        <Redirect from="/contracting/workspace/:contractId" to="/contracting/workspace/:contractId/documents"/>
        <Route component={ContractWorkspaceMainContent} path="/contracting/workspace/:contractId/documents" />
        <Route component={ContractActivities} path="/contracting/workspace/:contractId/activities" />
        <Route component={NotesInContracting} path="/contracting/workspace/:contractId/notes" />
      </Route>
      <Route component={ContractContainer} path="/contracting/contract/:contractId/details">
        <Route component={ContractPolicies} path="/contracting/contract/:contractId/policies" />
        <Route component={ContractActivities} path="/contracting/contract/:contractId/activities" />
        <Route component={NotesInContracting} path="/contracting/contract/:contractId/notes" />
        <Route component={ContractProduct} path="/contracting/contract/:contractId/product/:productId/:ratePackage" />
      </Route>
      <Route component={DraftContainer} path="/contracting/:collection/:contractId/details">
        <Route component={DraftNTemplatePolicies} path="/contracting/:collection/:contractId/policies" />
        <Route component={ContractProduct} path="/contracting/:collection/:contractId/product/:productId/:ratePackage" />
        <Route components={TemplatePartnersRouter} path="/contracting/:collection/:contractId/partners" />
      </Route>
      <Route components={TemplateChangeLog} path="/contracting/template/:threadId/logs" />
      <Route path="/contracting/contract-list" component={ContractListRouter}/>
      <Route path="/contracting/contract-list/:type" component={ContractListRouter}/>
      <Route component={TemplateListRouter}>
        <Route path="/contracting/template-list" component={MainTemplateList}/>
        <Route path="/contracting/supplier-updates-queue" component={SupplierUpdatesQueue}/>
        <Route path="/contracting/master-template-list" component={MasterTemplateList}/>
      </Route>
      <Route path="/contracting/create-template-group" component={TemplateGroupWizardRouter}/>
      <Route path="/contracting/create-template-draft" component={CreateTemplateDraftRouter}/>
      <Route component={MassRateChange} path="/contracting/mass-rate-change/:contractId/:updateType" />
      <Route component={ContractDashboard} path="/contracting/supplier-dashboard" />
      <Route component={ContractDashboard} path="/contracting/buyer-dashboard" />
      <Route component={ContractReports} path="/contracting/reports" />
      <Route component={DiffReportsRouter} path="/contracting/reports/diff">
        <Route component={DiffSelectDocs} path="/contracting/reports/diff/:collection/:baseId" />
        <Route component={DiffReports} path="/contracting/reports/diff/:collection/:baseId/:compareId" />
      </Route>
      <Route components={SupplierWizard}>
        <Route component={ContractRequestWizard} path="/contracting/supplier-wizard/:contractId" />
        <Route component={SupplierInitiatedWizardWithAlloments} path="/contracting/supplier-wizard-allotment" />
      </Route>
    </Route>
    <Redirect from="*" to="/dashboard" />
  </Route>
);



// WEBPACK FOOTER //
// ./src/app/routes.jsx